<template>
  <div class="page-content">
    <div class="title">
      Popular Products
    </div>
    <button
      v-if="addingProduct == false"
      @click="addingProduct = true"
      class="btn-info-button"
    >
      Add product
    </button>
    <table v-if="addingProduct" class="default-table">
      <tbody>
        <NewProductLine
          :priceAndQuantity="false"
          :edit="true"
          @addProduct="addProduct"
        />
      </tbody>
    </table>
    <div class="list">
      <div class="box" v-for="(product, index) in products" :key="index">
        <ProductListItem :product="product" />
        <div class="options">
          <a class="icon" @click="removeProduct(product)">
            <img src="@/assets/icons/trash.svg" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getPopularProducts,
  deleteProduct,
  addProduct as addPopularProductService
} from "@/api/store/PopularProductsService.js";
import ProductListItem from "@/components/product/ProductListItem.vue";
import NewProductLine from "@/components/order/NewProductLine.vue";

// import { debounce } from "lodash";
export default {
  name: "PopularProducts",
  components: {
    ProductListItem,
    NewProductLine
  },
  data() {
    return {
      products: [],
      error: null,
      addingProduct: false
    };
  },
  mounted() {
    this.loadProducts();
  },
  methods: {
    async loadProducts() {
      this.products = await getPopularProducts().catch(() => {
        this.error = "Error Loading Products.";
      });
    },
    removeProduct(product) {
      console.log(product);
      if (
        confirm(
          `Are you sure you want to remove this product?  ${product.part.nkrCode}`
        )
      ) {
        deleteProduct(product.part.nkrCode)
          .then(() => {
            this.products = this.products.filter(productOriginal => {
              return productOriginal.part.nkrCode != product.part.nkrCode;
            });
          })
          .catch(e => {
            console.log(e, "hubo un error");
          });
      }
    },
    addProduct(newProduct) {
      addPopularProductService(newProduct.nkrCode)
        .then(() => {
          let product = {
            part: {
              title: newProduct.description,
              nkrCode: newProduct.nkrCode
            },
            images: [
              {
                imageRoute: newProduct.image
              }
            ]
          };
          this.products.push(product);
        })
        .catch(e => {
          console.log(e, "error");
        });
      // 1 popular products service crear post function to create product
      // 2 si responde que esta bien hacer push del product al arreglo de producto para que se vea local
      // 3 te d
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/App.scss";
.list {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  .box {
    margin: 10px;
    height: 200px;
    width: 250px;
    overflow: hidden;
    padding: 5px;
    @extend .shadow-4dp;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 15px;
    text-align: center;
    position: relative;
    .options {
      display: none;
    }
    &:hover {
      .options {
        display: block;
        position: absolute;
        top: 10px;
        right: 10px;
        display: flex;
        flex-direction: row;
        .icon {
          border: 1px solid $M8;
          border-radius: 10px;
          padding: 5px;
          width: 30px;
          margin-left: 5px;
          img {
            width: 100%;
          }
        }
      }
    }
    .title {
      margin-top: 0px;
      margin-bottom: 10px;
    }
  }
}
</style>
